module.exports = __webpack_public_path__ + "img/22.52ad483a.png";